export const getPaginatedData = async (request, params) => {
  const data = [];

  // Load initial data and save to data array
  const initialResult = await request(params);
  if (
    initialResult.data.data.length > 0 &&
    !data.includes(...initialResult.data.data)
  ) {
    data.push(...initialResult.data.data);
  }

  // Calculate the amount of calls left to do
  const loopLength = Math.ceil(
    initialResult.data.total_count / params.itemsPerPage
  );

  // Since the initial call already loaded page 1, start the loop on the next page
  for (let i = 1; i < loopLength; i++) {
    const dataRes = await request({ ...params, page: i + 1 });
    if (dataRes.data.data.length > 0 && !data.includes(...dataRes.data.data)) {
      data.push(...dataRes.data.data);
    }
  }

  // Compose the result of this function
  const response = {
    data: data,
    totalCount: initialResult.data.total_count,
  };

  if (initialResult.data.metadata) {
    response.metadata = initialResult.data.metadata;
  }

  return response;
};

export const formateTimeRange = (range) => {
  const [startStr, endStr] = range.split("/");
  const startDate = new Date(startStr);
  const endDate = new Date(endStr);
  const formatDate = (date) => date.toISOString().split("T")[0];
  const formattedStart = formatDate(startDate);
  const formattedEnd = formatDate(endDate);
  return `${formattedStart}/${formattedEnd}`;
};

export const saveToState = (storageKey, data) => {
  const state = {};

  const dataKeys = Object.keys(data);
  dataKeys.forEach((key) => {
    state[key] = data[key];
  });

  const stateString = JSON.stringify(state);
  localStorage.setItem(storageKey, stateString);
};

export const loadFromState = (storageKey, stateFunctions) => {
  if (localStorage.getItem(storageKey) === null) {
    stateFunctions.forEach((stateFunction) =>
      stateFunction.stateFunc(stateFunction.defaultVal)
    );
    return;
  }

  const stateString = localStorage.getItem(storageKey);
  const state = JSON.parse(stateString);

  stateFunctions.forEach((stateFunction) => {
    stateFunction.stateFunc(
      state[stateFunction.storageObjectKey] ?? stateFunction.defaultVal
    );
  });
};

export const resetState = (storageKey, stateFunctions) => {
  localStorage.removeItem(storageKey);
  stateFunctions.forEach((stateFunction) => {
    stateFunction.stateFunc(stateFunction.nullVal);
  });
};

export const colors = [
  "rgb(31, 119, 180)", // Blue
  "rgb(255, 127, 14)", // Orange
  "rgb(44, 160, 44)", // Green
  "rgb(214, 39, 40)", // Red
  "rgb(148, 103, 189)", // Purple
  "rgb(23, 190, 207)", // Cyan
  "rgb(188, 189, 34)", // Yellow
  "rgb(227, 119, 194)", // Magenta
  "rgb(127, 127, 127)", // Grey
  "rgb(140, 86, 75)", // Brown
];

export const truncateId = (id) => {
  return `${id.slice(0, 4)}...${id.slice(id.length - 4, id.length)}`;
};
